import { call, put } from "typed-redux-saga";
import { PaymentUrlResponse } from "../../core/api/requests/payment/url/types";
import { paymentUrlApi } from "../../core/http/httpClient";
import { ApiResponse } from "../../core/types";
import { takeEveryFsa } from "../operations";
import { paymentActions } from "./actions";

export function* paymentSaga() {
  yield takeEveryFsa(paymentActions.getPaymentUrl.started, function* (action) {
    const { onComplete, onError, onSuccess, ...body } = action.payload;
    const { response, error }: ApiResponse<PaymentUrlResponse> = yield call(
      () => {
        return paymentUrlApi
          .call(body)
          .then((response) => ({ response }))
          .catch((error) => ({ error }));
      },
    );

    onComplete?.();

    if (!response || error) return onError?.(error);

    yield* put(
      paymentActions.getPaymentUrl.done({
        params: action.payload,
        result: response.data,
      }),
    );
    onSuccess?.({ url: response.data.url });
  });
}
